import React, { Component } from 'react';
import './react-datepicker.css';
import Calendar from 'react-datepicker';
import MaskedTextInput from 'react-text-mask';
import * as moment from 'moment';
import { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt';
registerLocale('pt', pt);

class DateInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      invalidDate: false,
    };
  }

  UNSAFE_componentWillMount() {
    var date;
    if (typeof this.state.value === 'string' && this.state.value !== '') {
      date = moment(this.state.value);
      this.setState({
        value: new Date(date.format()),
      });
    }

    if (typeof this.props.min === 'string' && this.props.min !== '') {
      date = moment(this.props.min);
      this.setState({
        min: new Date(this.props.min),
      });
    }

    if (typeof this.state.max === 'string' && this.state.max !== '') {
      date = moment(this.state.max);
      this.setState({
        max: new Date(this.state.max),
      });
    }
  }

  validarData(dateMoment) {
    var valid = true;

    if (isNaN(dateMoment)) valid = false;

    var minDate = moment(this.props.min).format('YYYY-MM-DD');
    var maxDate = moment(this.props.max).format('YYYY-MM-DD');
    var someDate = dateMoment.format('YYYY-MM-DD');

    if (this.props.min && someDate < minDate) valid = false;
    if (this.props.max && someDate > maxDate) valid = false;

    return valid;
  }

  enviarData(dt) {
    if (dt && dt !== '') {
      var data = moment(dt.toString());

      if (this.validarData(data)) {
        var dateFormat = moment(data.toString()).format('YYYY-MM-DD');
        this.props.onChange(dateFormat);
        this.setState({ value: dt, invalidDate: false });
      }
    }
  }

  onKeyUp(event) {
    if (event.keyCode === 13 && typeof this.props.onKeyPress === 'function') {
      this.props.onKeyPress(event);
    } else {
      event.preventDefault();
    }
  }

  render() {
    return (
      <div style={this.props.style}>
        <Calendar
          name={this.props.name}
          className={
            this.props.className
              ? this.props.className
              : '' + this.state.invalidDate
              ? ' invalid-date '
              : ''
          }
          locale='pt'
          selected={this.state.value}
          onChange={(e) => this.enviarData(e)}
          minDate={this.props.min}
          maxDate={this.state.max}
          dateFormat='dd/MM/yyyy'
          onKeyDown={this.onKeyUp.bind(this)}
          readOnly={this.props.readOnly}
          disabled={this.props.disabled}
          customInput={
            <MaskedTextInput
              readOnly={this.props.readOnly}
              disabled={this.props.disabled}
              type='text'
              value={moment(this.state.value.toString()).format('DD/MM/YYYY')}
              mask={[
                /^[0-9]/,
                /^[0-9]/,
                '/',
                /^[0-1]/,
                /^[0-9]/,
                '/',
                /^[0-2]/,
                /\d/,
                /\d/,
                /\d/,
              ]}
            />
          }
        />
      </div>
    );
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/componentes/datepicker/react-datepicker.component.js